import api from './api';

export const getContacts = (params) => api.get('/contacts/', { params });
export const getContactOptions = (params) => api.get('/contacts/options', { params });
export const getContact = (id) => api.get(`/contacts/${id}`);
export const getContactProfile = (number) => api.get(`/contacts/profile/${number}`);
export const getContactsList = (params) => api.get('/contacts/list', { params });
export const createContact = (data) => api.post('/contacts', data);
export const updateContact = (id, data) => api.put(`/contacts/${id}`, data);
export const deleteContact = (id) => api.delete(`/contacts/${id}`);
export const blockContact = (id) => api.put(`/contacts/block/${id}`, { active: false });
export const unblockContact = (id) => api.put(`/contacts/block/${id}`, { active: true });
export const toggleContactAcceptAudio = (id) => api.put(`/contacts/toggleAcceptAudio/${id}`);
export const importContactsFromWhatsApp = (data) => api.post('/contacts/import', data);
/** Planilha pronta vinda do backend — precisa de `responseType: 'blob'` no config. */
export const exportContacts = (params, config) =>
  api.get('/contacts/export', { params, ...config });
export const uploadContactsSpreadsheet = (formData) =>
  api.request({ url: '/contacts/upload', method: 'POST', data: formData });
export const uploadContactFile = (id, formData) => api.post(`/contacts/${id}/files`, formData);
export const deleteContactFile = (id, data) => api.delete(`/contacts/${id}/files`, { data });
export const toggleContactDisableBot = (id) => api.put(`/contacts/toggleDisableBot/${id}`);
export const blockContactWith = (id, data) => api.put(`/contacts/block/${id}`, data);
export const getContactTags = (contactId) => api.get(`/contactTags/${contactId}`);
